import React from 'react';
import PropTypes from 'prop-types';
import { useSelector, useDispatch } from 'react-redux';
import { Button } from 'react-bootstrap';
import {
	useRequestData,
	usePrefs,
	useLabels,
	useSitemap
} from 'wsm-common-data';
import { setClassNames } from 'ddc-classnames-js';
import { trackEvent } from '../utilities/tracking';
import { getPlacement } from '../utilities/aspect';
import { a } from '../global-constants';
import { setModalState } from '../actions/modalState';

const CtaButton = ({
	carouselPosition,
	customAsset = false,
	ctaButtonClasses = [],
	isVisible = true,
	label,
	url,
	promo
}) => {
	let button = null;
	const labels = useLabels();
	const sitemap = useSitemap();
	const { widgetName, windowId, deviceType } = useRequestData();
	const { aspectRatio } = usePrefs();
	const personalized = useSelector((state) => state.personalized);
	const dispatch = useDispatch();
	const leadFormURL = sitemap.get('PROMOTIONS_LEAD_FORM_FRAGMENT');

	const subscribeCloseLeadDialog = async () => {
		if (deviceType === 'DESKTOP') {
			$('body').on('dialogclose', () =>
				dispatch(setModalState({ type: a.CLOSE_MODAL }))
			);
		} else {
			$(document).on('slideClose', () =>
				dispatch(setModalState({ type: a.CLOSE_MODAL }))
			);
		}
	};

	const onClick = () => {
		const specialType = url === 'LEAD' ? 'dialog lead form' : 'click';
		if (url === 'LEAD') {
			dispatch(setModalState({ type: a.OPEN_MODAL }));
			subscribeCloseLeadDialog();
		}
		trackEvent({
			widgetName,
			windowId,
			event: 'specialsEvent',
			specialType,
			specialCategory:
				promo.type.charAt(0) + promo.type.slice(1).toLowerCase(),
			specialId: promo.id,
			specialPlacementType: getPlacement(aspectRatio),
			specialPersonalized: personalized,
			specialAutoGen: promo.autoGenerated,
			nonInteractive: false,
			carouselPosition,
			customAsset,
			oemId: promo.oemId,
			title: promo.title
		});
	};

	// Only display the button if we have an href and label
	if (url && url !== 'default' && label && label !== 'default') {
		// Set tabindex='-1' to hide offscreen Button from tabbing for A11Y
		// TODO: Need data-promo-tracking... attributes
		if (url === 'LEAD') {
			const leadForm = `${leadFormURL}?promotionId=${promo.id}`;
			button = (
				<Button
					role="button"
					className={setClassNames(['dialog', ctaButtonClasses])}
					onClick={() => {
						onClick();
					}}
					data-width="375"
					bsStyle="primary"
					bsSize="lg"
					href="#"
					data-title={label}
					data-href={leadForm}
					tabIndex={isVisible ? null : '-1'}
				>
					{label}
				</Button>
			);
		} else {
			button = (
				<Button
					role="button"
					className={ctaButtonClasses}
					onClick={() => {
						onClick();
					}}
					bsStyle="primary"
					bsSize="lg"
					href={url}
					target={promo?.ctaConfig?.openInNewTab ? '_blank' : '_self'}
					tabIndex={isVisible ? null : '-1'}
				>
					{label}
					<p className="sr-only">
						{promo?.ctaConfig?.openInNewTab
							? labels.get('OPEN_IN_NEW_TAB')
							: labels.get('OPEN_IN_SAME_TAB')}
					</p>
				</Button>
			);
		}
	}
	return button;
};

CtaButton.propTypes = {
	clickEvent: PropTypes.func,
	classes: PropTypes.arrayOf(PropTypes.string),
	isVisible: PropTypes.bool,
	label: PropTypes.string.isRequired,
	url: PropTypes.string.isRequired,
	promo: PropTypes.shape({}).isRequired
};

export default CtaButton;
